export enum ASK_AI_CONCEPTS {
    /**
     * @value Add synonyms
     */
    ADD_SYNONYMS = 'ASK_AI_CONCEPTS.ADD_SYNONYMS',
    /**
     * @value Associated rules
     */
    ASSOCIATED_RULES = 'ASK_LUMAPPS_CONCEPTS.ASSOCIATED_RULES',
    /**
     * @value {"one":"%NB_RULES% associated rule","other":"%NB_RULES% associated rules"}
     */
    ASSOCIATED_RULES_WITH_NUMBER = 'ASK_LUMAPPS_CONCEPTS.ASSOCIATED_RULES_WITH_NUMBER',
    /**
     * @value Expression
     * @description Word or phrase used as expression for ask-ai
     */
    CONCEPT = 'ASK_LUMAPPS_CONCEPTS.CONCEPT',
    /**
     * @value Expressions
     * @description Concepts entry for Ask Lumapps back office section
     */
    CONCEPTS = 'ASK_LUMAPPS_ADMIN.CONCEPTS',
    /**
     * @value All expressions must be in the query to trigger the AI.
     * @description Helper displayed below the concepts selector
     */
    CONCEPTS_SELECT_HELPER = 'ASK_LUMAPPS_CONCEPTS.CONCEPTS_SELECT_HELPER',
    /**
     * @value This expression already exist
     * @description Toaster message displayed when an expression already exists.
     */
    CONCEPT_ALREADY_EXISTS = 'ASK_LUMAPPS_CONCEPTS.CONCEPT_ALREADY_EXISTS',
    /**
     * @value Expression created.
     * @description Message displayed as notification when a new expression has just been created
     */
    CONCEPT_CREATED_NOTIFICATION = 'ASK_LUMAPPS_CONCEPTS.CONCEPT_CREATED_NOTIFICATION',
    /**
     * @value Expression deleted.
     * @description Notification displayed when deleting and expression
     */
    CONCEPT_DELETED_NOTIFICATION = 'ASK_LUMAPPS_CONCEPTS.CONCEPT_DELETED_NOTIFICATION',
    /**
     * @value Expression updated.
     * @description Notification displayed when an expression has been successfully updated.
     */
    CONCEPT_UPDATED_NOTIFICATION = 'ASK_LUMAPPS_CONCEPTS.CONCEPT_UPDATED_NOTIFICATION',
    /**
     * @value Deleting the %TITLE% expression is irreversible. Any associated rules will no longer be triggered by this expression.
     */
    CONFIRM_DELETE_CONCEPT = 'ASK_LUMAPPS_CONCEPTS.CONFIRM_DELETE_CONCEPT',
    /**
     * @value Delete expression?
     */
    DELETE_CONCEPT = 'ASK_LUMAPPS_CONCEPTS.DELETE_CONCEPT',
    /**
     * @value Enter an expression that has not yet been added
     * @description Error message displayed as field helper when an expression already exists.
     */
    DUPLICATED_ERROR_HELPER = 'ASK_LUMAPPS_CONCEPTS.DUPLICATED_ERROR_HELPER',
    /**
     * @value Edit expression
     */
    EDIT_CONCEPT = 'ASK_LUMAPPS_CONCEPTS.EDIT_CONCEPT',
    /**
     * @value Create expressions that Ask AI can detect to tailor answer.
     * @description Concept list empty state message
     */
    EMPTY_STATE_MESSAGE = 'ASK_LUMAPPS_CONCEPTS.EMPTY_STATE_MESSAGE',
    /**
     * @value Add a word or a phrase
     * @description Placeholder for keyword field when adding keywords for ask ai expression
     */
    KEYWORDS_FIELD_PLACEHOLDER = 'ASK_LUMAPPS_CONCEPTS.KEYWORDS_FIELD_PLACEHOLDER',
    /**
     * @value New expression
     * @description Create concept action label
     */
    NEW_CONCEPT = 'ASK_LUMAPPS_CONCEPTS.NEW_CONCEPT',
    /**
     * @value No associated rules
     */
    NO_ASSOCIATED_RULES = 'ASK_LUMAPPS_CONCEPTS.NO_ASSOCIATED_RULES',
    /**
     * @value No expressions yet
     * @description Concept list empty state title
     */
    NO_CONCEPT = 'ASK_LUMAPPS_CONCEPTS.NO_CONCEPT',
    /**
     * @value Select expressions
     * @description Placeholder displayed in the concept selector
     */
    SELECT_CONCEPTS = 'ASK_LUMAPPS_CONCEPTS.SELECT_CONCEPTS',
    /**
     * @value Synonyms
     */
    SYNONYMS = 'ASK_AI_CONCEPTS.SYNONYMS',
    /**
     * @value All word in the lexical will be added to the expression.
     * @description Helper for the option used for using the expression description  as a way for the AI to get more context on what the expression is about
     */
    USE_LEXICAL_MATCHING_HELPER = 'ASK_AI_CONCEPTS.USE_LEXICAL_MATCHING_HELPER',
    /**
     * @value Use the description to add the lexical field
     * @description Label for the option used for using the expression description  as a way for the AI to get more context on what the expression is about
     */
    USE_LEXICAL_MATCHING_LABEL = 'ASK_AI_CONCEPTS.USE_LEXICAL_MATCHING_LABEL',
    /**
     * @value Write a synonym and press "Enter"
     */
    WRITE_SYNONYM = 'ASK_AI_CONCEPTS.WRITE_SYNONYM',
}
